import React from 'react';
import styled from '@emotion/styled';
import { Box } from '~Styles';
import TopBar from './TopBar';
import { useDeviceInfo } from '~Hooks';

interface Props {
  children: React.ReactNode;
}

const Wrapper = styled.div<{
  isPhone: boolean;
}>`
  background: var(--colorBlueGray1200);
  overflow: hidden;
  color: var(--colorBlueGray300);
  position: relative;

  padding-top: ${({ isPhone }) => (isPhone ? '40px' : '0')};
`;

const MainContent = styled(Box)<{
  isPhone: boolean;
}>`
  height: calc(100vh - 52px - ${({ isPhone }) => (isPhone ? '40px' : '0px')});
  width: 100vw;
  position: relative;
  overflow-y: auto;
`;

export default function DefaultLayout({ children }: Props) {
  const deviceInfo = useDeviceInfo();

  return (
    <Wrapper isPhone={Boolean(deviceInfo?.isPhone)}>
      <TopBar />
      <MainContent isPhone={Boolean(deviceInfo?.isPhone)}>{children}</MainContent>
    </Wrapper>
  );
}
